import { render } from "./list-detail-panel-header.vue?vue&type=template&id=60e086c4&scoped=true&ts=true"
import script from "./list-detail-panel-header.vue?vue&type=script&lang=ts"
export * from "./list-detail-panel-header.vue?vue&type=script&lang=ts"

import "./list-detail-panel-header.vue?vue&type=style&index=0&id=60e086c4&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-60e086c4"]])

export default __exports__